import { render, staticRenderFns } from "./PatientFormDiagnosis.vue?vue&type=template&id=2cdbb735"
import script from "./PatientFormDiagnosis.vue?vue&type=script&lang=js"
export * from "./PatientFormDiagnosis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports